// extracted by mini-css-extract-plugin
export default {"teaser":"Home_teaser__WXMXl","Content":"Home_Content__jXXcl","clickText":"Home_clickText__yRE6p","cake":"Home_cake__mnMrJ"};